import styled from 'styled-components';

const ModalContent = styled.div`
	display: flex;
	height: 100%;
	padding: 0 40px 30px;
	align-items: center;
	flex-direction: column;
	justify-content: flex-end;
`;

const Close = styled.button`
	background-color: transparent;
	position: absolute;
	top: 12px;
	right: 15px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	ModalContent,
	Close,
};
